import { Suspense, lazy, use, useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

import Layout from "./components/Layout";
import FloatingButtons from "./components/FloatingButtons";

const Home = lazy(() => import("./pages/Home"));
const ServiceDetails = lazy(() => import("./pages/ServiceDetails"));
const ModalityDetails = lazy(() => import("./pages/ModalityDetails"));
const Contact = lazy(() => import("./pages/Contact"));



const RouteWrapper = () => {

  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0);

  }, [pathname])

  return (
    <Suspense
      fallback={
        <div className="min-h-screen bg-background text-on-surface" />
      }
    >
      <FloatingButtons />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="service/:slug" element={<ServiceDetails />} />
          <Route path="modality/:slug" element={<ModalityDetails />} />
          <Route path="contact" element={<Contact />} />
        </Route>
      </Routes>
    </Suspense>

  )
}


function App() {



  return (
    <BrowserRouter>
      <RouteWrapper />
    </BrowserRouter>
  );
}

export default App;
